<template>
  <div class="row">
    <div class="col">
      <!-- //* Curriculum Vitae -->
      <div class="row">
        <div class="col mt-4">
          <h2 class="section-title text-uppercase">Curriculum Vitae</h2>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col">
          <div class="alert alert-info" role="alert">
            Importez votre CV au format <b>PDF</b> (10 Mo maximum).
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12 col-12">
          <label for="cv" class="form-label required">CV</label>
          <input
            class="form-control"
            id="cv"
            type="file"
            accept="application/pdf"
            ref="cv"
            :disabled="uploading"
            @change="uploadCv"
          />
          <div id="cvHelp" class="form-text">
            Seulement les fichiers <b>PDF</b> sont acceptés. La taille du fichier
            ne doit pas dépasser <b>10 Mo</b>.
          </div>
          <div class="text-danger small mt-1" v-if="cvError">
            Le CV est obligatoire.
          </div>

          <div class="mt-3" v-if="uploading">
            <span class="text-muted">Importation en cours...</span>
          </div>

          <div class="mt-3" v-if="cvUploaded">
            <div
              class="alert alert-success d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-2"
              role="alert"
            >
              <span>CV importé avec succès.</span>
              <div class="d-flex flex-shrink-0 gap-2">
                <a
                  class="btn btn-sm btn-primary text-white"
                  href="#"
                  @click.prevent="showFile(cvPath)"
                  role="button"
                >
                  Voir
                </a>
                <button
                  type="button"
                  class="btn btn-sm btn-danger text-white"
                  @click="removeCv"
                >
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4 text-center text-md-start">
        <button
          class="btn btn-lg btn-primary"
          @click="$emit('to-previous')"
          type="button"
        >
          Précédent
        </button>
        <button
          class="btn btn-lg btn-primary ms-sm-2 mt-2 mt-sm-0"
          type="button"
          @click="onSubmit"
        >
          Soumettre mon dossier
        </button>
      </div>

      <div class="row mb-4">
        <div class="mt-3 fst-italic">
          <span class="text-muted">
            <label class="required"></label> Obligatoire
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EeiaAttachments",
  inject: [
    "ToastSuccess",
    "ToastError",
    "currentYearUrl",
    "AlertWarning",
    "AlertSuccess",
    "AlertError",
    "ToastWarning",
  ],
  props: {
    previousData: Object,
    step: Number,
    previousAttachments: Object,
    stepTwoCategory: String,
  },
  mounted() {
    this.loadExistingCv();
    window.scrollTo(0, 0);
  },
  data() {
    return {
      cvUploaded: false,
      cvPath: "",
      uploading: false,
      cvError: false,
    };
  },
  methods: {
    loadExistingCv() {
      let attachments =
        this.previousAttachments && this.previousAttachments.attachments
          ? this.previousAttachments.attachments
          : [];

      let cv = attachments.find(
        (attachment) => attachment.attachment_type === "curriculum-vitae"
      );

      if (cv) {
        this.cvUploaded = true;
        this.cvPath = cv.path;
      }
    },
    uploadCv() {
      let file = this.$refs.cv.files.item(0);

      if (!file) {
        return;
      }

      let formData = new FormData();
      formData.append("attachment_type", "curriculum-vitae");
      formData.append("attachment", file);

      this.uploading = true;

      this.$http
        .post("attachment/store", formData)
        .then((response) => {
          this.cvUploaded = true;
          this.cvPath = response.data.path;
          this.cvError = false;
          this.ToastSuccess.fire({
            title: "CV importé avec succès",
          });
        })
        .catch((error) => {
          this.$refs.cv.value = "";

          if (
            Object.prototype.hasOwnProperty.call(error.response, "status") &&
            error.response.status == 422
          ) {
            let message = "Veuillez bien remplir le formulaire et réessayez.";
            if (
              Object.prototype.hasOwnProperty.call(
                error.response.data,
                "errors"
              ) &&
              Object.prototype.hasOwnProperty.call(
                error.response.data.errors,
                "attachment"
              )
            ) {
              message = error.response.data.errors.attachment[0];
            }
            this.ToastError.fire({ title: message });
          } else if (
            Object.prototype.hasOwnProperty.call(error.response, "status") &&
            error.response.status == 403
          ) {
            this.AlertError.fire({
              icon: "error",
              title: "Non autorisé",
              html: "Vous ne pouvez plus modifier votre candidature.",
            });
          } else {
            this.ToastError.fire({
              title: "Une erreur s'est produite, veuillez réessayer.",
            });
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    removeCv() {
      this.AlertWarning.fire({
        title: "Attention!",
        text: "Voulez-vous vraiment supprimer votre CV ?",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          formData.append("path", this.cvPath);

          this.$http
            .post("/attachment/delete", formData)
            .then(() => {
              this.cvUploaded = false;
              this.cvPath = "";
              this.$refs.cv.value = "";
              this.ToastSuccess.fire({ title: "CV supprimé !" });
            })
            .catch((error) => {
              if (error.response.status == 403) {
                this.AlertError.fire({
                  icon: "error",
                  title: "Non autorisé",
                  html: "Vous ne pouvez plus modifier votre candidature.",
                });
              } else {
                this.AlertError.fire({
                  icon: "error",
                  title: "Echec !",
                  text: "Désolé, une erreur s'est produite. Veuillez réessayer.",
                });
              }
            });
        }
      });
    },
    onSubmit() {
      if (!this.cvUploaded) {
        this.cvError = true;
        this.AlertError.fire({
          icon: "error",
          title: "Pièce manquante",
          html: "Le <b>CV</b> est obligatoire.",
        });
        return;
      }

      this.AlertWarning.fire({
        title: "Confirmation !",
        html: `
          Souhaitez-vous définitivement soumettre votre dossier de candidature ?
          <br>
          Une fois soumis, <b>il ne sera plus modifiable</b>.`,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, soumettre",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        let formData = new FormData();
        formData.append("step", 6);

        this.$http
          .post("new-candidacies", formData)
          .then(() => {
            this.AlertSuccess.fire({
              title: "",
              text: "Votre dossier de candidature a été envoyé avec succès !",
            });
            localStorage.setItem("currentStep", 1);
            window.scrollTo(0, 0);
            this.$emit("evaluation-sent");
          })
          .catch((error) => {
            if (error.response.status == 403) {
              this.AlertError.fire({
                icon: "error",
                title: "Non autorisé",
                html: "Vous ne pouvez plus modifier votre candidature.",
              });
            } else {
              this.ToastError.fire({
                title: "Une erreur s'est produite, veuillez réessayer.",
              });
            }
          });
      });
    },
    showFile(filename) {
      var windowReference = window.open();
      this.$http({
        url: "attachment/show",
        method: "GET",
        params: {
          filename: filename,
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileContent = response.data;
          this.$http({
            url: "attachment/get-mime-type",
            method: "GET",
            params: {
              filename: filename,
            },
          })
            .then((response) => {
              const file = new Blob([fileContent], {
                type: response.data,
              });
              const fileUrl = URL.createObjectURL(file);
              windowReference.location.assign(fileUrl);
            })
            .catch(() => {
              this.ToastError.fire({
                icon: "error",
                title: "Echec !",
                text: "Désolé, une erreur s'est produite. Veuillez réessayer.",
              });
            });
        })
        .catch(() => {
          this.ToastError.fire({
            icon: "error",
            title: "Echec !",
            text: "Désolé, une erreur s'est produite. Veuillez réessayer.",
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 768px) {
  .form-control,
  .form-select {
    line-height: 2;
  }
}

.section-title {
  border-bottom: 3px solid #3490dc;
}
</style>
